import React, { useEffect, useState } from "react";
import axios from "../../axios-instance";

import './ShareTicketAccept.sass';

export const ShareTicketAccept = (props) => {
  const params = new URL(window.location.href).searchParams;
  const accessToken = params.get("accessToken");
  const seatLabel = params.get("seatLabel");
  const [message, setMessage] = useState('');

  const getMessage = async () => {
    try {
      const { data } = await axios.get(`/Membership/acceptReplaceSeat?accessToken=${accessToken}&seatLabel=${seatLabel}`);
      setMessage(data);
    } catch (e) {
      setMessage(e.response.data);
    }
  }

  useEffect(() => {
    getMessage();
  }, [])
  
  return (
    <section className="share-ticket-accept">
      <div className="share-ticket-accept__container">
        <div className="seasonpass-pers-info__logo seasonpass-pers-info__header-logo-wrapper share-ticket-accept__logo"></div>

        <p className="share-ticket-accept__message">
          {message}
        </p>
      </div>
    </section>
  )
}
